module.exports = __webpack_public_path__ + "img/full1-min.97052cd5.png";